export const CHILD_ROWS_EXAMPLE_DATA = [
  {
    id: 'SHA',
    title: 'Mr',
    name: 'Jacob Shaw',
    gender: 'male',
    email: 'jacob.shaw@example.com',
    age: 99,
    salary: '€ 88,646',
    registered: '2005-09-04T03:09:06.480Z',
  },
  {
    userId: 'SHA',
    addressId: 'SHA-1',
    street: 'Schlossallee 9',
    city: '9020010 Saltcastle',
    email: 'jacob.shaw@home.com',
  },
  {
    userId: 'SHA',
    addressId: 'SHA-2',
    street: 'Road 42',
    city: '9020010 Saltcastle',
    email: 'jacob.shaw@office.com',
  },
  {
    id: 'COR',
    title: 'Ms',
    name: 'Angela Cortes',
    gender: 'female',
    email: 'angela.cortes@example.com',
    age: 19,
    salary: '€ 32,133',
    registered: '2016-03-10T12:35:00.807Z',
  },
  {
    id: 'GOM',
    title: 'Miss',
    name: 'Lorena Gomez',
    gender: 'female',
    email: 'lorena.gomez@example.com',
    age: 7,
    salary: '$ 348,089',
    registered: '2015-07-05T22:09:00.189Z',
  },
  {
    userId: 'GOM',
    addressId: 'GOM-1',
    street: 'Default road 1',
    city: '9020011 Citytown',
    email: 'its.me.gomez@home.com',
  },
  {
    id: 'BOL',
    title: 'Mr',
    name: 'Davut Bolatlı',
    gender: 'male',
    email: 'davut.bolatli@example.com',
    age: 29,
    salary: '$ 8,075',
    registered: '2012-08-22T09:17:03.289Z',
  },
];
